import React from 'react';
import Faqs from '@gcloud-npm/next12.components.faqs-m';

// TODO: adecuar el data.json a los inputs de <Faqs> en kit
const FaqsWrapper = (props) => {
  return (
    <section className="FaqsSection">
      <Faqs {...props} />
    </section>
  );
};

export default FaqsWrapper;
